<!-- src/lib/components/Nav.svelte  或  src/routes/+layout.svelte 中的 <nav> 部分 -->
<script>
  import { inertia } from '@inertiajs/svelte';
  import { onMount } from 'svelte';
  import { Link } from '@inertiajs/svelte';
  import { usePage } from '@inertiajs/svelte';
  import { buttonVariants } from "$lib/components/ui/button";

  import SunIcon from "@lucide/svelte/icons/sun";
  import MoonIcon from "@lucide/svelte/icons/moon";
  import Check from "@lucide/svelte/icons/check";
  import PackageCheck from "@lucide/svelte/icons/package-check";
  import {Rocket} from '@lucide/svelte';

    const page = usePage();
  $: auth = $page.props.auth || {};          // 安全取值
  $: user = auth.user || null;
  $: loggedIn = !!user;                      // 是否登录
  $: username = user?.name || '游客';
  
  let showBanner = false;

  // 記住使用者是否關閉過 banner（用 localStorage）
  onMount(() => {
    if (localStorage.getItem('bannerDismissed') === 'true') {
      showBanner = false;
    }

    console.log(auth);
  });

  function dismissBanner() {
    showBanner = false;
    localStorage.setItem('bannerDismissed', 'true');
  }

  // mobile menu 狀態
  let mobileOpen = false;
</script>

<!-- 公告橫幅 -->
{#if showBanner}
  <div class="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
    <div aria-hidden="true" class="absolute top-1/2 left-[max(-7rem,calc(50%-52rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl">
      <div
        style="clip-path: polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)"
        class="aspect-577/310 w-144.25 bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30"
      ></div>
    </div>
    <div aria-hidden="true" class="absolute top-1/2 left-[max(45rem,calc(50%+8rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl">
      <div
        style="clip-path: polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)"
        class="aspect-577/310 w-144.25 bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30"
      ></div>
    </div>

    <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
      <p class="text-sm/6 text-gray-900">
        <strong class="font-semibold">2026春装2展</strong>
        <svg viewBox="0 0 2 2" aria-hidden="true" class="mx-2 inline size-0.5 fill-current">
          <circle r="1" cx="1" cy="1" />
        </svg>
        请于6月7日至9日加入我们，了解接下来会发生什么。
      </p>
      <a
        href="/register" use:inertia
        class="flex-none rounded-full bg-gray-900 px-3.5 py-1 text-sm font-semibold text-white shadow-xs hover:bg-gray-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
      >
        现在注册
        <span aria-hidden="true">→</span>
      </a>
    </div>

    <div class="flex flex-1 justify-end">
      <button
        type="button"
        on:click={dismissBanner}
        class="-m-3 p-3 focus-visible:-outline-offset-4"
      >
        <span class="sr-only">Dismiss</span>
        <svg viewBox="0 0 20 20" fill="currentColor" class="size-5 text-gray-900">
          <path
            d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
          />
        </svg>
      </button>
    </div>
  </div>
{/if}

<!-- 主導航 -->
<nav class="relative bg-white dark:bg-neutral-900 border-b">
  <div class="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
    <div class="relative flex h-16 items-center justify-between">

      <!-- Logo + title -->
      <div class="flex flex-1 items-center sm:items-stretch sm:justify-start">
        <div class="flex flex-col shrink-0 items-center justify-center">
          <Link href="/" class="flex items-center space-x-1 text-2xl text-gray-900 dark:text-white">
            <Rocket /><span class="font-bold">分太极光</span>
          </Link>
        </div>

        <!-- Desktop menu （目前是空的，你可以之後加） -->
        <div class="hidden sm:ml-6 sm:block">
          <!-- <DesktopMenu /> -->
        </div>
      </div>

      <!-- Auth links -->
      <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0 space-x-4">
        
        {#if !loggedIn}
          <a href="/register" use:inertia>注册</a>
          <a href="/login" use:inertia>登录</a>
        {:else}
        { username }
          <Link
            href="/logout"
            method="delete"
            as="button"
            class={buttonVariants({ variant: "outline" })}
          >退出</Link>
          <!-- 如果用 form + POST，可以改成 <form method="POST" action="/logout"> ... -->
        {/if}
      </div>
    </div>
  </div>

  <!-- Mobile menu panel -->
  {#if mobileOpen}
    <div class="block sm:hidden bg-white border-t">
      <div class="space-y-1 px-2 pt-2 pb-3">
        <!-- 這裡放 mobile 專屬的選單項目 -->
        <!-- 例如： -->
        <a href="/" use:inertia class="block rounded-md px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50">首页</a>
        <!-- ... 其他連結 -->
      </div>
    </div>
  {/if}
</nav>